export const IOS_INSTALL =
  "https://apps.apple.com/kr/app/%EC%95%A0%EB%8B%88%ED%8D%BC%ED%94%BC-%EB%B0%98%EB%A0%A4%EB%8F%99%EB%AC%BC-%EB%B9%84%EB%AC%B8-%EB%8F%99%EB%AC%BC%EB%93%B1%EB%A1%9D-%EC%95%B1/id6449179098";
export const ANDROID_INSTALL =
  "https://play.google.com/store/apps/details?id=com.iscilab.app.anipuppy";
export const NAVER_CAFE_LINK = "https://cafe.naver.com/sillimhappyin";
export const NAVER_CAFE_LINK_NEWS =
  "https://cafe.naver.com/f-e/cafes/31387977/menus/14?viewType=I";
export const NAVER_CAFE_LINK_NEW =
  "https://cafe.naver.com/f-e/cafes/31387977/menus/0";

export const MAIL_LINK = "mailto:contact@anipuppy.com";
export const KAKAO_LINK = "http://pf.kakao.com/_xfmxbcb";
export const DONUS = "https://secure.donus.org/happyin/pay/step1";
